<!-- TODO: i18n -->
<app-system-page-layout>
  <ng-container header-title-controls>
    <button mat-raised-button class="accent_success" (click)="create()">
      <mat-icon>
        add
      </mat-icon>
      Create Avatar
    </button>
  </ng-container>
  <ng-container content>
    <app-system-avatar-list (tileClicked)="edit($event)"></app-system-avatar-list>
  </ng-container>
</app-system-page-layout>
